export enum ImageActions {
  UploadImage = 'image/upload-image',
}

export interface UploadImageStateProps {
  uploadImage: boolean;
  url: string;
  id: string;
  pair?: string;
}

export interface ImageStateProps {
  uploadImage: UploadImageStateProps;
}

export interface ImageBasePayload<T extends ImageActions, V = null> {
  type: T;
  payload: V;
}

export type SetUploadImagePayload = ImageBasePayload<
  ImageActions.UploadImage,
  UploadImageStateProps
>;

export type ImagePayload = SetUploadImagePayload;
